/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100133 セット商品マスタ出力
 */
import { Box } from "@mui/material";
import {
  B000200SetShohinNmFrom,
  B000200SetShohinNmTo,
  B100133ExcelRequest,
  B100133GetExcel,
  catchFileError,
} from "clients/rest";
import {
  msgState,
  SConfirmDialog,
  SFileButton,
  SFrame,
  SLabel,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { labels } from "messages/labels";
import { B000200 } from "pages";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { download } from "services";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  setshohinCdFrom: string;
  setshohinNmFrom: string;
  setshohinCdTo: string;
  setshohinNmTo: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  setshohinCdFrom: "",
  setshohinNmFrom: "",
  setshohinCdTo: "",
  setshohinNmTo: "",
};

const focusId = "B100133";

export const B100133 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 画面遷移
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 初期表示イベント
  useEffect(() => {
    // 初回フォーカス先
    focus(1);
  }, []);

  // EXCELボタン押下時
  const handleClickExcelButton = () => {
    const fields = methods.getValues();

    const param: B100133ExcelRequest = {
      setshohinCdFrom: fields.setshohinCdFrom!,
      setshohinCdTo: fields.setshohinCdTo!,
    };

    B100133GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B100133_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="セット商品マスタ出力"
        gridTemplateColumns="8rem 8rem 15rem 1rem 8rem 15rem 5rem"
      >
        <SText gridColumn="span 7">　</SText>

        <SLabel>セット商品コード</SLabel>
        <SNumberField
          name="setshohinCdFrom"
          code
          size={10}
          {...register(1)}
          onBlur={() => B000200SetShohinNmFrom(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("setshohinCdFrom", data.shohinCd);
            methods.setValue("setshohinNmFrom", data.shohinNm);
          }}
        />
        <STextField name="setshohinNmFrom" disabled />
        <SText>～</SText>
        <SNumberField
          name="setshohinCdTo"
          code
          size={10}
          {...register(2)}
          onBlur={() => B000200SetShohinNmTo(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("setshohinCdTo", data.shohinCd);
            methods.setValue("setshohinNmTo", data.shohinNm);
          }}
        />
        <STextField name="setshohinNmTo" disabled />
        <Box />

        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>
        <SText gridColumn="span 3">　</SText>

        <Box gridColumn="span 5" />
        <SFileButton
          label={labels.buttons.excel}
          align="right"
          {...register(3)}
          dialog={
            <SConfirmDialog
              title="セット商品マスタ出力"
              msg={labels.dialog.masterExcelConfirmMessage}
            />
          }
          dialogAction="confirm"
          handleSubmit={handleClickExcelButton}
        />
      </SFrame>
    </FormProvider>
  );
};
